import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../../utils";

export const updateTehsil = createAsyncThunk('updateTehsil', async (data) => {

    try {
        const res = await axios({

            method: 'PUT',
            url: process.env.REACT_APP_API_URL + 'tehsil',
            data: {
                "tehsil_id": data?.values?.id,
                "district_id": data?.values?.district,
                "tehsil_name": data?.values?.name,
                "status": data?.values?.status
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})